module.exports = __webpack_public_path__ + "img/01Boton_02.1191a2cb.svg";